import * as Yup from 'yup';

const cpfRegex = /^\d{11}$/;

export const buildRegistrationSchema = () =>
  Yup.object().shape({
    full_name: Yup.string().trim().min(3, 'Mínimo 3 caracteres').required('Obrigatório'),
    cpf: Yup.string()
      .transform(v => (v || '').replace(/\D/g, ''))
      .matches(cpfRegex, 'CPF inválido')
      .required('Obrigatório'),
    birth_date: Yup.date().max(new Date(), 'Data inválida').required('Obrigatório'),
    email: Yup.string().email('Email inválido').required('Obrigatório'),
    phone: Yup.string()
      .transform(v => (v || '').replace(/\D/g, ''))
      .min(10, 'Telefone inválido')
      .required('Obrigatório'),
    regional_id: Yup.number().required('Selecione a regional'),
    institution_id: Yup.number().required('Selecione a unidade'),
    current_education_level: Yup.string().oneOf(['fundamental_2', 'medio_1', 'medio_2', 'medio_3', 'concluido', 'outro']).required('Obrigatório'),
    desired_grade: Yup.string().required('Obrigatório'),
    preferred_shift: Yup.string().oneOf(['morning', 'afternoon', 'evening']).required('Obrigatório'),
    special_needs: Yup.boolean(),
    special_needs_description: Yup.string().when('special_needs', {
      is: true,
      then: s => s.required('Descreva as necessidades especiais')
    }),
    lgpd_accepted: Yup.boolean().oneOf([true], 'Aceite obrigatório').required(),
    honeypot: Yup.string()
  });
